import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAssetConnectionsParamsRawI,
	LWApiPublicAssetConnectionsResultRawI,
} from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ASSET_CONNECTIONS_QUERY_KEY = '/asset/connections';

const useAssetConnections = (
	params: LWApiPublicAssetConnectionsParamsRawI,
	options?: UseQueryOptions<LWApiPublicAssetConnectionsResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [ASSET_CONNECTIONS_QUERY_KEY, params],
		queryFn: () => api.asset.apiRaw.connections(params),
		...options,
	});

export default useAssetConnections;
